export const CONTACT_PHONE_DISPLAY = '+90 538 205 52 09';
export const CONTACT_PHONE_TEL = '+905382055209';
export const CONTACT_PHONE_WHATSAPP = '905382055209';
